import { Stack } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import React from "react";
import { scrollbarStyle } from "../../../shared/dashboard";
import { EmailBody } from "../../../types/files";
import useEmailPreview from "../../../hooks/useEmailPreview";
import FormattedEmailBody from "../../atoms/FormattedEmailBody";

const useStyles = makeStyles(() => ({
    emailBlock: {
        width: '100%',
        height: '100%',
        overflowY: 'auto',
        ...scrollbarStyle,
    },
    bodyText: {
        fontFamily: 'Inter',
        fontSize: '0.85rem',
        color: '#334155',
        textAlign: 'left',
        wordBreak: 'break-word',
    },
}));

const EmailContent: React.FC<{ content: EmailBody }> = ({ content }) => {
    const classes = useStyles();
    const email = useEmailPreview(content);

    return (<>
        <Stack className={classes.emailBlock}>
            <FormattedEmailBody content={email.rawContent} className={classes.bodyText} />
        </Stack>
    </>);
}

export default EmailContent;
